import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";

export default function MaxUsersSelect({
  value,
  onChange,
  label = "Max Users:",
  labelWidth = "100px",
  fullWidth = false,
  style = {},
  disabled = false,
  editmode = false,
}) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(parseInt(e.target.value) || 0);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Typography
        variant="body2"
        sx={{ mb: 1, fontWeight: 500, width: labelWidth }}
      >
        {label}
      </Typography>
      <FormControl fullWidth={fullWidth} style={style}>
        <Select
          value={value}
          onChange={handleChange}
          disabled={disabled}
          sx={{
            borderRadius: 5,
            backgroundColor: "white",
            "& .MuiSelect-icon": {
              color: "#667eea",
            },
          }}
        >
          <MenuItem key={0} value={0}>
            None
          </MenuItem>
          {Array.from({ length: 9 }, (_, i) => (
            <MenuItem key={i + 2} value={i + 2}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Chip
                  label={`/${i + 2}`}
                  size="small"
                  sx={{
                    backgroundColor: "#FF385D",
                    color: "white",
                    fontWeight: 500,
                  }}
                />
                <Typography variant="body2" color="text.secondary">
                  {i + 2}
                </Typography>
              </Box>
            </MenuItem>
          ))}
          <MenuItem key={12} value={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Chip
                label={`/${12}`}
                size="small"
                sx={{
                  backgroundColor: "#FF385D",
                  color: "white",
                  fontWeight: 500,
                }}
              />
              <Typography variant="body2" color="text.secondary">
                {12}
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem key={20} value={20}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Chip
                label={`/${20}`}
                size="small"
                sx={{
                  backgroundColor: "#FF385D",
                  color: "white",
                  fontWeight: 500,
                }}
              />
              <Typography variant="body2" color="text.secondary">
                {20}
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem key={50} value={50}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Chip
                label={`/${50}`}
                size="small"
                sx={{
                  backgroundColor: "#FF385D",
                  color: "white",
                  fontWeight: 500,
                }}
              />
              <Typography variant="body2" color="text.secondary">
                {50}
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem key={100} value={100}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Chip
                label={`/${100}`}
                size="small"
                sx={{
                  backgroundColor: "#FF385D",
                  color: "white",
                  fontWeight: 500,
                }}
              />
              <Typography variant="body2" color="text.secondary">
                {100}
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem key={1000} value={1000}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Chip
                label={`/${1000}`}
                size="small"
                sx={{
                  backgroundColor: "#FF385D",
                  color: "white",
                  fontWeight: 500,
                }}
              />
              <Typography variant="body2" color="text.secondary">
                {1000}
              </Typography>
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
